// export const API_URL = "https://rednationadminstagingapi.apptunix.com/admin/";
export const API_URL = "https://admin-api.rednation.app/admin/";
// export const API_URL = "https://redadminapi.appgrowthcompany.com/admin/";

export const END_POINTS = {
  login: "onboarding/login",
  upload: "media/uploadFile",
  updateUser: "onboarding",
  get_user: "onboarding/getProfile",
  logout: "onboarding/logout",
  forgotPassword: "onboarding/forgotPassword",
  verifyOtp: "onboarding/verifyOtp",
  resetPassword: "onboarding/resetPassword",
  changePassword: "onboarding/changePassword",
  uploadMedia: "media/uploadFile/",
  dashboardData: "/master/dashboard",
  employeGraph: "/master/employerGraph",
  taskGraph: "/master/taskGraph",
  freelancerGraph: "/master/freelancerGraph",
  dashboardGraph: "dashboardGraph",
  cmsSetting: "cmsSetting",
  updateCms: "cms",
  getCms: "cms",
  category: "/category",
  services: "/services",
  users: "users",
  export: "/users/export",
  faq: "faq",
  accessRole: "subadminaccess",
  masterData: "/master/masterData",
  subadmin: "subadmin",
  reorderCategory: "/category/reorder",
  task: "/users/task",
  taskDetails: "/users/taskDetails",
  freelancersList: "/users/freelancersList",
  portfolioList: "/users/portfolio",
  work: "/users/work",
  workDetails: "users/taskDetails",
  rating: "/booking/rating",
  payment: "/payment/paymentList",
  paymentExport: "/payment/export",
  notification: "/notification",
  analytics: "/master/earningGraph",
  Tasks: "/booking/taskList",
  commission: "/master/settings",
  refundList: "/booking/refundList",
  refund: "/booking/refund",
  walletList: "/booking/walletList",
  walletRefund: "/booking/wallet",
  payout: "/booking/payoutList",
};
